import {
  PLAN_GET_PLANBATCH_LIST_ACTION_BEGIN,
  PLAN_GET_PLANBATCH_LIST_ACTION_SUCCESS,
  PLAN_GET_PLANBATCH_LIST_ACTION_FAILURE,
  PLAN_GET_PLANBATCH_LIST_ACTION_DISMISS_ERROR,
} from './constants';
import request from '../../../utils/request'
// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function getPlanbatchListAction(params) {
  return (dispatch) => { // optionally you can have getState as the second argument
    dispatch({
      type: PLAN_GET_PLANBATCH_LIST_ACTION_BEGIN,
    });
params.size = 10
    // Return a promise so that you could control UI flow without states in the store.
    // For example: after submit a form, you need to redirect the page to another when succeeds or show some errors message if fails.
    // It's hard to use state to manage it, but returning a promise allows you to easily achieve it.
    // e.g.: handleSubmit() { this.props.actions.submitForm(data).then(()=> {}).catch(() => {}); }
    const promise = new Promise((resolve, reject) => {
      // doRequest is a placeholder Promise. You should replace it with your own logic.
      // See the real-word example at:  https://github.com/supnate/rekit/blob/master/src/features/home/redux/fetchRedditReactjsList.js
      // args.error here is only for test coverage purpose.
      request({
        url:'/api/gc/batch/lng',
        method:'get',
        data:params,
      }).then(
        (res) => {
          dispatch({
            type: PLAN_GET_PLANBATCH_LIST_ACTION_SUCCESS,
            data: Object.assign({},res,{page:params.page}),
          });
          resolve(res);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: PLAN_GET_PLANBATCH_LIST_ACTION_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissGetPlanbatchListActionError() {
  return {
    type: PLAN_GET_PLANBATCH_LIST_ACTION_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case PLAN_GET_PLANBATCH_LIST_ACTION_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        getPlanbatchListActionPending: true,
        getPlanbatchListActionError: null,
      };

    case PLAN_GET_PLANBATCH_LIST_ACTION_SUCCESS:
      // The request is success
      //  console.log(action)
        const byId = {};
        const items = [];
        action.data.data.forEach(item => {
          items.push(item.id);
          byId[item.id] = item;
        });
      return {
        ...state,
        PlanbatchById:byId,
        PlanbatchLIst:items,
        PlanbatchPage:action.data.page,
        PlanbatchSize:action,
        PlanbatchTotal:action.data.totalCount,
        getPlanbatchListActionPending: false,
        getPlanbatchListActionError: null,
      };

    case PLAN_GET_PLANBATCH_LIST_ACTION_FAILURE:
      // The request is failed
      return {
        ...state,
        getPlanbatchListActionPending: false,
        getPlanbatchListActionError: action.data.error,
      };

    case PLAN_GET_PLANBATCH_LIST_ACTION_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        getPlanbatchListActionError: null,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/plan/redux/getPlanbatchListAction.js